import React from 'react';

import { AuthProvider } from "./auth";
import { ToastProvider } from "./toast";
import { UsuarioLogadoProvider } from "./usuarioLogado";

const AppProvider: React.FC = ({ children }) => (
   <AuthProvider>
       <UsuarioLogadoProvider>
           <ToastProvider>{children}</ToastProvider>
       </UsuarioLogadoProvider>
   </AuthProvider>
)

export default AppProvider